import { Injectable } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';

export interface NavState{
  items:NbMenuItem[];
  selectedItem?:NbMenuItem;
  subMenuItems?:NbMenuItem[];
}

export const navState:NavState = {
  items:undefined,
  selectedItem:undefined,
  subMenuItems:undefined
}

@Injectable({
  providedIn: 'root'
})
export class NavStateService extends ComponentStore<NavState>{
  items:NbMenuItem[];  
  
  init(items:NbMenuItem[]):void{
    this.items = items;
    console.log(this.items)
    this.loadConfig();
  }

  constructor(private menuService:NbMenuService,) {
    super(navState);
    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        console.log(menuBag);
      })
   }

  loadConfig = this.effect<void>(
    trigger$ => trigger$.
    pipe(
      map(() => {
        console.log(this.items)
        this.updateNavState(this.items)
      })
    )
  )

  //Updaters
  readonly updateNavState = this.updater((state:NavState,items:NbMenuItem[]) => {
    return{
      ...state,
      items:items
    }
  })

  readonly updateSelectedItem = this.updater((state:NavState,selectedItem:NbMenuItem) => {
    console.log(selectedItem)
    return{
      ...state,
      selectedItem:selectedItem
    }
  })
  readonly updateSubMenuItems = this.updater((state:NavState,subMenuItems:NbMenuItem[]) => {
    console.log(subMenuItems);
    return{
      ...state,
      subMenuItems:subMenuItems
    }
  })

  //selectors
  readonly items$:Observable<NbMenuItem[]> = this.select(state => state.items);
  readonly subMenuItems$:Observable<NbMenuItem[]> = this.select(state => state.subMenuItems);
  readonly selectedItem$:Observable<NbMenuItem> = this.select(state => state.selectedItem);

  //Effects
  readonly setSelectItem = this.effect((contentId$:Observable<string>) => {
    return contentId$.pipe(
      tap((contentId:string) => {
        console.log(contentId)
        console.log(this.items);
        let selectedItem = this.findMenuItem(this.items,contentId);
        if(selectedItem != undefined){
          console.log({FoundIt:selectedItem});
          this.updateSelectedItem(selectedItem);
          //Filter the children
          let children = this.items.filter(item => item.data["parentContentId"] == selectedItem.data["contentId"]);
          if(children != undefined){
            this.updateSubMenuItems(children);
          }
        }
       
      })
    )
  })

  findMenuItem(items:NbMenuItem[],contentId:string){
    console.log("Finding the item from",items)
    console.log("Finding the item from state items",this.items)
    for(const item of items){
      if(item.data["contentId"] == contentId){
        return item;
      }
      if(item.children){
        console.log("checking children");
        const found = this.findMenuItem(item.children,contentId);
        if(found){
          return found
        }
      }
    }
    return undefined
  }

  
}
